// Temas de la supervisión visual. El cliente elige el suyo en su catálogo
// (backend/clientes/<cliente>.json → "theme"); si no existe, se usa "oficina".
import estudio from './estudio';
import oficina from './oficina';

const THEMES = { estudio, oficina };

export function getTheme(id) {
  return THEMES[id] || oficina;
}
